
import { Pipe, PipeTransform } from '@angular/core';
import { EsignField } from './esignature-setup.component';

@Pipe({ name: 'hasUnassigned' })
export class HasUnassignedPipe implements PipeTransform {
  transform(fields: EsignField[]): boolean {
    if (!fields) return false;
    return fields.some(f => f.type !== 'redact' && !f.assignedUserId);
  }
}
